import { make } from 'vuex-pathify';
import GraphQL from '../../api/graphql';

const state = {
    id: null,
    name: '',
    email: '',
    password: '',
    group: '',
    groups: [],
    users: []
};

const mutations = make.mutations(state);

const actions = {
    async createUser({ dispatch, rootState, state }) {
        const { name, email, password, group } = state;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($name: String!, $email: String!, $password: String!, $group: ID!) {
                    createUser(name: $name, email: $email, password: $password, group: $group) {
                        id
                    }
                }
            `,
            variables: {
                name,
                email,
                password,
                group
            }
        });

        await dispatch('fetch');
        this.set('users/name', '');
        this.set('users/email', '');
        this.set('users/password', '');
        this.set('users/group', '');
        this.set('users/id', null);
    },

    async deleteUser({ dispatch, rootState }, id) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation ($id: ID!) {
                    deleteUser(id: $id)
                }
            `,
            variables: {
                id
            }
        });

        await dispatch('fetch');
    },

    async fetch({ rootState }) {
        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        const response = await client.query({
            query: `
                query {
                    users {
                        id
                        name
                        email
                        group {
                            id
                            name
                        }
                    }

                    groups {
                        id
                        name
                    }
                }
            `,
            variables: {}
        });

        const users = response.data.users.map((user) => {
            return {
                id: user.id,
                name: user.name,
                email: user.email,
                group: user.group.name,
                groupId: user.group.id
            };
        });

        this.set('users/users', users);
        this.set('users/groups', response.data.groups);
    },

    reset() {
        this.set('users/id', null);
        this.set('users/name', '');
        this.set('users/email', '');
        this.set('users/password', '');
        this.set('users/group', '');
        this.set('users/groups', []);
        this.set('users/users', []);
    },

    async updateUser({ dispatch, rootState, state }) {
        const { id, name, email, password, group } = state;

        const client = new GraphQL({
            headers: {
                authorization: `Bearer ${rootState.auth.access_token}`
            }
        });

        await client.query({
            query: `
                mutation($id: ID!, $name: String, $email: String, $password: String, $group: ID) {
                    updateUser(id: $id, name: $name, email: $email, password: $password, group: $group) {
                        id
                    }
                }
            `,
            variables: {
                id,
                name,
                email,
                password,
                group
            }
        });

        await dispatch('fetch');
        this.set('users/name', '');
        this.set('users/email', '');
        this.set('users/password', '');
        this.set('users/group', '');
        this.set('users/id', null);
    }
};

export default { state, actions, mutations };
